import React, { useCallback, useState } from 'react';
import FilterMainPanel from './containers/Filter-Main-Panel';
import FilterDetailPanel from './containers/Filter-Detail-Panel';
import { useAppDispatch, useAppSelector } from '../../core/rootHooks';
import { selectSelectedFilter } from './filterSelectors';
import { AppDispatch } from '../../core/store';
import { setSelectedFilterRequest } from './filterSlice';

interface IFilterProps {
	setActiveLeftSidebarMenu: (value: string) => void;
}

const Filter: React.FC<IFilterProps> = ({ ...props }) => {
	const [isFilterDetailOpen, setIsFilterDetailOpen] = useState(false);

	// Get subscribed vessels from redux store
	const dispatch = useAppDispatch<AppDispatch>();
	const selectedFilter = useAppSelector(selectSelectedFilter);

	const handleDisplayFilterDetailPanel = useCallback(
		(value: boolean, filterId: number | null, tempId?: string, isDraft?: boolean) => {
			setIsFilterDetailOpen(value);
			dispatch(setSelectedFilterRequest({ id: filterId, tempId: tempId, isDraft: isDraft }));
		},
		[dispatch],
	);

	const handleCloseFilterDetail = useCallback(() => {
		setIsFilterDetailOpen(false);
		dispatch(setSelectedFilterRequest({ id: null }));
	}, [dispatch]);

	return (
		<div className="fixed flex flex-row inset-0 bg-black/50 z-10" style={{ top: 64, left: 0, bottom: 40 }}>
			<div className={`bg-msi-white-color absolute`} style={{ top: 11, left: 88, bottom: 10 , width: "300px"}}>
				<FilterMainPanel
					displayFilterDetailPanel={handleDisplayFilterDetailPanel}
					displayFilterMainPanel={props.setActiveLeftSidebarMenu}
					key="filter-main-panel"
					title="Load Filter"
					isDetailOpen={isFilterDetailOpen}
					selectedFilter={selectedFilter}
				/>
			</div>
			{isFilterDetailOpen && (
				<div
					className={`bg-msi-white-color ease-in-out duration-300 ${isFilterDetailOpen ? 'translate-x-0' : 'translate-x-full'} absolute`}
					style={{ top: 11, left: 388, bottom: 10 }}
				>
					<FilterDetailPanel
						key={selectedFilter?.id ?? 'add-new-filter'}
						closeFilterDetail={handleCloseFilterDetail}
						displayFilterMainPanel={props.setActiveLeftSidebarMenu}
					/>
				</div>
			)}
		</div>
	);
};

export default Filter;
